import React from 'react';
import '../styles/TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">

        <h1>Terms of Service</h1>

        <p className="effective-date">
          Effective Date: January 1, 2026
        </p>

        <p className="intro-text">
          Welcome to Mosaic Digital Creations. By accessing or using our
          website and services, you agree to comply with and be bound by
          the following Terms of Service.
        </p>

        <section>
          <h2>Acceptance of Terms</h2>

          <p>
            By using this website, you agree to these Terms of Service and
            all applicable laws and regulations. If you do not agree with
            any part of these terms, please do not use our website or services.
          </p>
        </section>

        <section>
          <h2>Services</h2>

          <p>
            Mosaic Digital Creations provides digital services including,
            but not limited to:
          </p>

          <ul>
            <li>Web Design & Development</li>
            <li>SEO & Digital Marketing</li>
            <li>Mobile App Development</li>
            <li>UI/UX Design</li>
            <li>Hosting & Maintenance</li>
            <li>Technology Consulting</li>
            <li>Creative Media Services</li>
          </ul>

          <p>
            Service availability and pricing may change without notice.
          </p>
        </section>

        <section>
          <h2>User Responsibilities</h2>

          <p>
            You agree to use this website and our services lawfully and
            responsibly.
          </p>

          <p>
            You must not:
          </p>

          <ul>
            <li>Use the website for unlawful purposes</li>
            <li>Attempt to gain unauthorized access to systems or data</li>
            <li>Distribute malicious software or harmful content</li>
            <li>Interfere with website functionality or security</li>
          </ul>
        </section>

        <section>
          <h2>Intellectual Property</h2>

          <p>
            All website content, branding, graphics, logos, text, and
            materials are the property of Mosaic Digital Creations unless
            otherwise stated.
          </p>

          <p>
            You may not copy, reproduce, or distribute website content
            without written permission.
          </p>
        </section>

        <section>
          <h2>Payments & Project Agreements</h2>

          <p>
            Certain services may require separate agreements, proposals,
            invoices, or contracts.
          </p>

          <p>
            Payment terms, timelines, revisions, and deliverables will be
            outlined individually for each project.
          </p>
        </section>

        <section>
          <h2>Limitation of Liability</h2>

          <p>
            Mosaic Digital Creations shall not be held liable for any
            indirect, incidental, or consequential damages resulting from
            the use of our website or services.
          </p>

          <p>
            We make reasonable efforts to maintain accurate information and
            website functionality but do not guarantee uninterrupted or
            error-free operation.
          </p>
        </section>

        <section>
          <h2>Third-Party Links</h2>

          <p>
            Our website may contain links to third-party websites or services.
            We are not responsible for the content, policies, or practices
            of external websites.
          </p>
        </section>

        <section>
          <h2>Termination</h2>

          <p>
            We reserve the right to suspend or terminate access to our
            website or services if these Terms of Service are violated.
          </p>
        </section>

        <section>
          <h2>Changes to These Terms</h2>

          <p>
            We may update these Terms of Service periodically. Updated terms
            will be posted on this page with a revised effective date.
          </p>
        </section>

        <section>
          <h2>Contact Information</h2>

          <p>
            If you have questions regarding these Terms of Service,
            please contact us:
          </p>

          <div className="contact-box">
            <p><strong>Mosaic Digital Creations</strong></p>
            <p>Email: info@mosaicdigitalcreations.com</p>
            <p>Website: https://www.mosaicdigitalcreations.com</p>
          </div>
        </section>

      </div>
    </div>
  );
};

export default TermsOfService;